require("-!style!css!./../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-7e56f776&file=list.vue!less!./../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./list.vue")
module.exports = require("-!babel!./../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./list.vue")

if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function" ? module.exports.options : module.exports).template = require("-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./list.vue")
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "D:\\coffce\\vue-chat\\src\\components\\list.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/list.vue
 ** module id = 34
 ** module chunks = 0
 **/